module.exports = __webpack_public_path__ + "img/chevron-left.82128ee.png";